var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[("" + _vm.cssPrefix),
    (_vm.cssPrefix + "--" + _vm.theme),
    ( _obj = {}, _obj[(_vm.cssPrefix + "--disabled")] = _vm.disabled, _obj ),
    ( _obj$1 = {}, _obj$1[(_vm.cssPrefix + "--default")] = _vm.asDefault, _obj$1 ) ],attrs:{"disabled":_vm.disabled,"type":"button"}},[_vm._t("default",[_vm._v(_vm._s(_vm.name))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }